export function updateProposalParams(
  current: URLSearchParams,
  updates: Record<string, string | number | null>,
  resetPage = true,
): URLSearchParams {
  const next = new URLSearchParams(current);
  if (resetPage) next.set("page", "1");
  for (const [key, value] of Object.entries(updates)) {
    if (value === null || value === "") next.delete(key);
    else next.set(key, String(value));
  }
  return next;
}
export function proposalCsvCell(value: unknown): string {
  let text = String(value ?? "");
  if (/^[\s]*[=+@\-]/.test(text) || /^[\t\r\n]/.test(text)) text = `'${text}`;
  return `"${text.replaceAll('"', '""')}"`;
}
